var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLovePair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 16.8C2 16.082 2.55964 15.5 3.25 15.5H10.75C11.4404 15.5 12 16.082 12 16.8C12 19.6719 9.76142 22 7 22C4.23858 22 2 19.6719 2 16.8Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 11.6C9.5 13.0359 8.38071 14.2 7 14.2C5.61929 14.2 4.5 13.0359 4.5 11.6C4.5 10.1641 5.61929 9 7 9C8.38071 9 9.5 10.1641 9.5 11.6Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.8C12 16.082 12.5596 15.5 13.25 15.5H20.75C21.4404 15.5 22 16.082 22 16.8C22 19.6719 19.7614 22 17 22C14.2386 22 12 19.6719 12 16.8Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 11.6C19.5 13.0359 18.3807 14.2 17 14.2C15.6193 14.2 14.5 13.0359 14.5 11.6C14.5 10.1641 15.6193 9 17 9C18.3807 9 19.5 10.1641 19.5 11.6Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7847 8.36947C9.60777 7.44093 8 5.90707 8 4.45681C8 2.03402 10.2001 1.12947 12 3.00105C13.7999 1.12947 16 2.03402 16 4.45679C16 5.90709 14.3922 7.44095 13.2153 8.36948C12.6825 8.78983 12.4161 9 12 9C11.5839 9 11.3175 8.78982 10.7847 8.36947Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLovePair);
export default __webpack_public_path__ + "static/media/love-pair.da849582f808596d673b53d39d5702f2.svg";
export { ForwardRef as ReactComponent };